// Interruptor único: cambia a `true` para volver a mostrar y habilitar
// la sección "Calcular horarios" (link en el menú + ruta); `false` la oculta por completo.
export const MOSTRAR_CALCULAR_HORARIOS = false;

// Igual que arriba, pero para "Acomodamiento de Salones" (asigna solo el salón a un
// Excel que ya trae horarios y días llenos).
export const MOSTRAR_ACOMODAMIENTO_SALONES = false;
